import React from "react";
import "./CustomTabMenu.css";
import { Tab } from "semantic-ui-react";
const CustomTabMenu = ({ panes }) => {
  return (
    <div>
      <Tab
        menu={{
          secondary: true,
          pointing: true,
          className: "tab-menu-container",
        }}
        panes={panes}
      />
    </div>
  );
};

export default CustomTabMenu;
